import MaterialCheckbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  label: {
    display: 'flex',
    fontSize: theme.typography.fontSizeSm,
    flexDirection: props => props.flexDirection,
    height: '36px',
    padding: '0 10px',
    marginBottom: 0,
    '& > span:hover, & > span.Mui-checked:hover': {
      background: 'none',
    },
    '&.right': {
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
    },
    '&.isLabelInline': {
      padding: '0',
    },
    '& .the-checkbox': {
      height: '36px',
    },
    '& > span': {
      height: '36px',
    },
    '& .MuiIconButton-label': {
      width: '18px',
    },
    '& .withBorder': {
      padding: '0',
      '&:hover, &.Mui-checked:hover': {
        background: 'transparent',
      },
    },
    '&.Mui-disabled $customBox': {
      borderColor: 'rgba(204,204,204,0.7)',
    },
  },
  checkbox: {
    width: '36px',
    height: '36px',
    padding: '0 !important',
    '&.Mui-disabled': {
      color: `${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`} !important`,
    },
  },
  customBox: {
    width: '18px',
    height: '18px',
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '2px',
  },
})

class FormCheckbox extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { isChecked: props.isChecked }
    this.onChecked = this.onChecked.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { isChecked } = this.state
    if (nextProps.isChecked !== isChecked) {
      this.setState({ isChecked: nextProps.isChecked })
    }
  }

  onChecked(isChecked) {
    const { onChecked } = this.props
    this.setState({ isChecked }, () => {
      onChecked(isChecked)
    })
  }

  render() {
    const {
      type,
      isDisabled,
      labelPlacement,
      bottomBorder,
      onChecked,
      classes,
      className,
      customMargin,
      customPadding,
      customCol,
      customWidth,
      isRequired,
      label,
      disabled,
      errorText,
      flexDirection,
      fullWidth,
      helperText,
      id,
      isLabelInline,
      isToolTip,
      justify,
      labelIcon,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
      ...rest
    } = this.props

    const { isChecked } = this.state

    return (
      <LabelWrapper
        className={className}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        label={label}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        multipleFields={multipleFields}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <span className={cn(classes.label, labelPlacement, { isLabelInline })}>
          <MaterialCheckbox
            color={type}
            disableRipple
            disabled={isDisabled || disabled}
            checked={isChecked}
            flexDirection={flexDirection}
            // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
            onChange={(event, value) => this.onChecked(value)}
            icon={<div className={cn(classes.customBox, isDisabled && 'disabled', 'unChecked')} />}
            id={id}
            className={cn({ disabled, withBorder }, classes.checkbox, labelPlacement)}
            style={customWidth ? { width: `${customWidth}px` } : {}}
            {...rest}
          />
        </span>
      </LabelWrapper>
    )
  }
}

FormCheckbox.defaultProps = {
  isDisabled: false,
  isChecked: false,
  className: '',
  bottomBorder: false,
  flexDirection: 'row',
  type: 'primary',
  onChecked: f => f,
  labelPlacement: 'right',
  isRequired: false,
  notWrapper: true,
}

const FormCheckboxComponent = withStyles(styles)(FormCheckbox)
FormCheckboxComponent.displayName = 'FormCheckbox'
export default FormCheckboxComponent
